import { ReactNode, forwardRef } from 'react';

import {
  DialogTitle,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export type HeaderProps = WithStyles<typeof styles> & {
  className?: string;
  children?: ReactNode;
};

export const Header = forwardRef<HTMLDivElement, HeaderProps>((props, ref) => {
  const { className, classes, children } = props;
  return (
    <DialogTitle
      disableTypography
      ref={ref}
      className={classNames(classes.root, className)}
    >
      {children}
    </DialogTitle>
  );
});

Header.displayName = 'DialogComposite.Header';

export default withStyles(styles)(Header);
